'use strict';
const angular = require('angular');
const {isFunction} = angular;

module.exports = [
  TransformerMixin];

/**
 * Controller support API for Transformer Directives
 * @returns {Function}
 * @constructor
 */
function TransformerMixin() {
  return function ($scope, vm) {

    var initialMode = null;

    var unwatchApi = $scope.$watch(function () {
      return isFunction(vm.$changeMode);
    }, function (isReady) {
      if (isReady) {
        initialMode && vm.$changeMode(initialMode);
        unwatchApi();
      }
    });

    return {
      changeMode: changeMode
    };

    function changeMode(mode) {
      if (isFunction(vm.$changeMode)) {
        vm.$changeMode(mode);
      } else {
        initialMode = mode;
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/core-utilities/transformer-directive/TransformerMixin.js